module.exports = __webpack_public_path__ + "media/images/logo-03fc9378f5b21b4323779d381e45d7e1.png";